import {
  content,
  descriptionStyle,
  img,
  scroller,
  sliding,
  slidingReversed,
  titleStyle,
} from "./index.css"

type Props = {
  before: {
    image: string
    title: string
    alt: string
  }
  after: {
    image: string
    title: string
    alt: string
  }
  description?: string
  height?: string
  width?: string
  yPosition?: `${number}px` | `${number}%` | `${number}rem`
  marginTop?: `${number}px` | `${number}%` | `${number}rem`
  marginBottom?: `${number}px` | `${number}%` | `${number}rem`
}

function ScrollyWolly({
  before,
  after,
  marginTop,
  marginBottom,
  description,
  height,
  width,
  yPosition,
}: Props) {
  return (
    <>
      <div
        className={scroller}
        style={{
          ...(height ? { height } : {}),
          ...(width ? { width } : {}),
          ...(marginTop ? { marginTop } : {}),
          ...(marginBottom ? { marginBottom } : {}),
        }}
      >
        <img
          className={img}
          src={before.image}
          alt={before.alt}
          style={yPosition ? { objectPosition: `center ${yPosition}` } : undefined}
          loading="lazy"
        />
        <img
          className={`${img} ${sliding}`}
          src={after.image}
          alt={after.alt}
          loading="lazy"
          style={yPosition ? { objectPosition: `center ${yPosition}` } : undefined}
        />
        <article className={content} style={height ? { height } : {}}>
          <h4 className={`${titleStyle} ${slidingReversed}`}>{before.title}</h4>
          <h4 className={`${titleStyle} ${sliding}`}>{after.title}</h4>
        </article>
      </div>
      {description && <p className={descriptionStyle}>{description}</p>}
    </>
  )
}

export default ScrollyWolly
